// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.wrapper__ec1 {
  .label__e17 {
    color: var(--ring-secondary-color);
    font-size: var(--ring-font-size-smaller);
    line-height: var(--ring-line-height-lowest);
  }

  .loaderWrapper__ef2 {
    height: calc(var(--ring-unit) * 3.5);
  }

  .label__e17 + .loaderWrapper__ef2 {
    margin-top: calc(var(--ring-unit) * 0.5);
  }

  .label__e17 + .select__ed8 {
    margin-top: calc(var(--ring-unit) * 0.5);
  }
}
`, "",{"version":3,"sources":["webpack://./src/modules/ide-provisioner/plugins-rules/plugins-rule/single-plugin-rule/common/plugin-selector/plugin-selector.css"],"names":[],"mappings":"AAAA;EACE;IACE,kCAAkC;IAClC,wCAAwC;IACxC,2CAA2C;EAC7C;;EAEA;IACE,oCAAoC;EACtC;;EAEA;IACE,wCAAwC;EAC1C;;EAEA;IACE,wCAAwC;EAC1C;AACF","sourcesContent":[".wrapper {\n  .label {\n    color: var(--ring-secondary-color);\n    font-size: var(--ring-font-size-smaller);\n    line-height: var(--ring-line-height-lowest);\n  }\n\n  .loaderWrapper {\n    height: calc(var(--ring-unit) * 3.5);\n  }\n\n  .label + .loaderWrapper {\n    margin-top: calc(var(--ring-unit) * 0.5);\n  }\n\n  .label + .select {\n    margin-top: calc(var(--ring-unit) * 0.5);\n  }\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"wrapper": `wrapper__ec1`,
	"label": `label__e17`,
	"loaderWrapper": `loaderWrapper__ef2`,
	"select": `select__ed8`
};
export default ___CSS_LOADER_EXPORT___;
